import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=5c1d225c&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=5c1d225c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d225c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1d225c')) {
      api.createRecord('5c1d225c', component.options)
    } else {
      api.reload('5c1d225c', component.options)
    }
    module.hot.accept("./MainView.vue?vue&type=template&id=5c1d225c&scoped=true", function () {
      api.rerender('5c1d225c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/MainView.vue"
export default component.exports